import { useTranslation } from "react-i18next";
import type { AxiosResponse } from "axios";

import { notify } from "@components/atoms/notify";
import type { IPromiseNotifProps } from "@/components/atoms/notify/types";
import type { IApiResponse } from "@/api";

type INotifyPromiseOptions<T> = Partial<
  Pick<
    IPromiseNotifProps<T>,
    "pendingMessage" | "rejectMessage" | "resolvedMessage"
  >
>;

export function useNotifyPromise<T>(
  options?: INotifyPromiseOptions<AxiosResponse<IApiResponse<T>>>,
) {
  return useCustomNotifyPromise<AxiosResponse<IApiResponse<T>>>({
    ...options,
    resolvedMessage() {
      // TODO: !important message
      return { text: /* data?.data.message ||*/ "" };
    },
  });
}

export function useCustomNotifyPromise<T>(
  globalOptions?: INotifyPromiseOptions<T>,
) {
  const { t } = useTranslation("common");

  return function <TData extends T = T>(
    promise: Promise<TData>,
    localOptions?: INotifyPromiseOptions<TData>,
  ): Promise<TData> {
    const options = localOptions || globalOptions;

    return notify.promise<TData>({
      promise,
      pendingMessage: options?.pendingMessage || t("notif.isProcessing"),
      rejectMessage: options?.rejectMessage || {
        text: t("notif.errorOccurred"),
      },
      resolvedMessage: (data) => {
        if (options?.resolvedMessage) {
          if (typeof options.resolvedMessage === "function") {
            return options.resolvedMessage(data);
          }
          return options.resolvedMessage;
        }
        return { text: t("notif.successfulOperation") };
      },
    });
  };
}
